import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = {
  email?: string;
  offerId: number;
  frequencyId?: string;
};

type TOutput = {
  msg?: string;
  status?: string;
  error_id?: string;
  name?: string;
};

export default class CreateWatchdogApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;
  allowedStatusCodes = [403];

  // domainUrl = "https://pronajmy-2968.staging.ulovdomov.cz";

  resolveUri(): string {
    return `/fe-api/watchdog/add-by-offer`;
  }

  mapRequestData({ email, offerId, frequencyId }: TInput): any {
    return {
      offer_id: offerId,
      email,
      frequency_id: frequencyId,
    };
  }
}
